import { del, extractErrorMessage, get, patch, post, ResponseApi } from "src/helpers/api_helper"
import { IConfig, IGroup, IReportedMessage, ISetting, IUser, IUserDetail, ResponsePagination, ResponseRequest } from "./types"

interface IGroupId {
    setting_type_id: string;
}

export const getGroups = async (): Promise<ResponseRequest<IGroup[]>> => {
    try {
        const response = await get<IGroup[]>('/groups')
        if (response.code === 200) {
            return { result: "ok", data: response?.data! }
        } else { 
            return { result: "error", message: response.message } 
        }
    } catch (error) {
        const message = extractErrorMessage(error)
        return { result: "error", message }
    }
}

export const createGroup = async ( data: Partial<IGroup> ): Promise<ResponseRequest<IGroup>> => {
    try {
        const response = await post<IGroup>(`/groups`, data)
        if (response.code === 200) {
            return { result: "ok", data: response.data! }
        } else { 
            return { result: "error", message: response.message } 
        }
    } catch (error) {
        const message = extractErrorMessage(error)
        return { result: "error", message }
    }
}

export const updateGroup = async ( id: string, data: Partial<IGroup> ): Promise<ResponseRequest<IGroup>> => {
    try {
        const response = await patch<IGroup>(`/groups/${id}`, data)
        if (response.code === 200) {
            return { result: "ok", data: response.data! }
        } else { 
            return { result: "error", message: response.message } 
        }
    } catch (error) {
        const message = extractErrorMessage(error)
        return { result: "error", message }
    }
}

export const updateGroupUser = async ( userId: string, groupId: string,): Promise<ResponseRequest<any>> => {
    try {
        const response = await patch<IUser>(`/users/${userId}/group`, { groupId})
        if (response.code === 200) {
            return { result: "ok", data: response.data! }
        } else { 
            return { result: "error", message: response.message } 
        }
    } catch (error) {
        const message = extractErrorMessage(error)
        return { result: "error", message }
    }
}

export const removeGroupUser = async ( userId: string, groupId: string,): Promise<ResponseRequest<any>> => {
    try {
        const response = await del<IUser>(`/users/${userId}/group`, { params: { groupId } })
        if (response.code === 200) {
            return { result: "ok", data: response.data!, message: response?.message }
        } else { 
            return { result: "error", message: response.message } 
        }
    } catch (error) {
        const message = extractErrorMessage(error)
        return { result: "error", message }
    }
}

export const deleteGroup = async ( id: string ): Promise<ResponseRequest<IGroup>> => {
    try {
        const response = await del<IGroup>(`/groups/${id}`)
        if (response.code === 200) {
            return { result: "ok", data: response.data! }
        } else { 
            return { result: "error", message: response.message } 
        }
    } catch (error) {
        const message = extractErrorMessage(error)
        return { result: "error", message }
    }
}